import { render, staticRenderFns } from "./complaintNew.vue?vue&type=template&id=2c414442&scoped=true&"
import script from "./complaintNew.vue?vue&type=script&lang=js&"
export * from "./complaintNew.vue?vue&type=script&lang=js&"
import style0 from "./complaintNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./complaintNew.vue?vue&type=style&index=1&id=2c414442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c414442",
  null
  
)

export default component.exports